import {
  FETCH_DRIVER_TRIPS_REQUEST,
  FETCH_DRIVER_TRIPS_SUCCESS,
  FETCH_DRIVER_TRIPS_FAILURE,

  UPDATE_DRIVER_TRIP_REQUEST,
  UPDATE_DRIVER_TRIP_SUCCESS,
  UPDATE_DRIVER_TRIP_FAILURE,

  DELETE_DRIVER_TRIP_REQUEST,
  DELETE_DRIVER_TRIP_SUCCESS,
  DELETE_DRIVER_TRIP_FAILURE,
} from "./types";

import {
  fetchDriverTrips,
  updateDriverTrip,
  deleteDriverTrip,
} from "../../services/driverTripService";


// Fetch Driver Trips


export const fetchDriverTripsRequest = () => ({
  type: FETCH_DRIVER_TRIPS_REQUEST,
});

export const fetchDriverTripsSuccess = (
  trips
) => ({
  type: FETCH_DRIVER_TRIPS_SUCCESS,
  payload: trips,
});

export const fetchDriverTripsFailure = (
  error
) => ({
  type: FETCH_DRIVER_TRIPS_FAILURE,
  payload: error,
});


// Update Driver Trip


export const updateDriverTripRequest = () => ({
  type: UPDATE_DRIVER_TRIP_REQUEST,
});

export const updateDriverTripSuccess = (
  trip
) => ({
  type: UPDATE_DRIVER_TRIP_SUCCESS,
  payload: trip,
});

export const updateDriverTripFailure = (
  error
) => ({
  type: UPDATE_DRIVER_TRIP_FAILURE,
  payload: error,
});


// Delete Driver Trip


export const deleteDriverTripRequest = () => ({
  type: DELETE_DRIVER_TRIP_REQUEST,
});

export const deleteDriverTripSuccess = (
  tripId
) => ({
  type: DELETE_DRIVER_TRIP_SUCCESS,
  payload: tripId,
});

export const deleteDriverTripFailure = (
  error
) => ({
  type: DELETE_DRIVER_TRIP_FAILURE,
  payload: error,
});

// ====================================
// THUNKS
// ====================================


// Fetch Driver Trips


export const fetchDriverTripsAction = (
  page = 1,
  size = 10
) => async (dispatch) => {
  dispatch(fetchDriverTripsRequest());

  try {
    const response = await fetchDriverTrips(
      page,
      size
    );

    if (response.success) {
      dispatch(
        fetchDriverTripsSuccess(
          response.data
        )
      );
    } else {
      dispatch(
        fetchDriverTripsFailure(
          response.error
        )
      );
    }
  } catch (error) {
    dispatch(
      fetchDriverTripsFailure(
        error.message ||
          "Failed to fetch driver trips"
      )
    );
  }
};


// Update Driver Trip


export const updateDriverTripAction =
  (tripId, payload) =>
  async (dispatch) => {
    dispatch(
      updateDriverTripRequest()
    );

    try {
      const response =
        await updateDriverTrip(
          tripId,
          payload
        );

      if (response.success) {
        dispatch(
          updateDriverTripSuccess(
            response.data
          )
        );

        return response;
      } else {
        dispatch(
          updateDriverTripFailure(
            response.error ||
              response.message
          )
        );

        return response;
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        "Failed to update driver trip";

      dispatch(
        updateDriverTripFailure(
          errorMessage
        )
      );

      return {
        success: false,
        error: errorMessage,
      };
    }
  };


// Delete Driver Trip


export const cancelDriverTripAction =
  (tripId) =>
  async (dispatch) => {
    dispatch(
      deleteDriverTripRequest()
    );

    try {
      const response =
        await deleteDriverTrip(tripId);

      if (response.success) {
        dispatch(
          deleteDriverTripSuccess({
            trip_id: tripId,
            status: "CANCELLED",
          })
        );

        return response;
      } else {
        dispatch(
          deleteDriverTripFailure(
            response.error ||
              response.message
          )
        );

        return response;
      }
    } catch (error) {
      const errorMessage =
        error.message ||
        "Failed to cancel driver trip";

      dispatch(
        deleteDriverTripFailure(
          errorMessage
        )
      );

      return {
        success: false,
        error: errorMessage,
      };
    }
  };